import React, { useState, useEffect } from "react";
import { Card, CardContent, Grid, Typography, useMediaQuery, useTheme, Box } from "@mui/material";

export const SummaryCards = ({ data = [], userData, selectedBrokerCorreo }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [currentIndex, setCurrentIndex] = useState(0);

    const isAdmin = userData && userData.tipoCuenta === 0;

    let displayData = isAdmin ? data : data.filter((item) => {
        if (!userData || !item.correo) return false;
        return item.correo.trim().toLowerCase() === userData.mail.trim().toLowerCase();
    });

    if (isAdmin && selectedBrokerCorreo) {
        displayData = displayData.filter((item) => item.correo === selectedBrokerCorreo);
    }

    const totalIngresoMensual = displayData.reduce(
        (acc, curr) => acc + (curr.ingreso_Mes ?? 0),
        0
    );
    const totalMetaTrimestral = displayData.reduce(
        (acc, curr) => acc + (curr.meta_Trimestral ?? 0),
        0
    );
    const totalIngresos = displayData.reduce(
        (acc, curr) => acc + (curr.ingreso_Anual ?? 0),
        0
    );
    const totalMetaAnual = displayData.reduce(
        (acc, curr) => acc + (curr.meta_Anual ?? 0),
        0
    );
    const avgAvance = totalMetaAnual > 0
        ? ((totalIngresos / totalMetaAnual) * 100).toFixed(1)
        : "0.0";
    const totalCierres = displayData.reduce(
        (acc, curr) => acc + (curr.n_Cierres_Anual ?? 0),
        0
    );

    const cardsData = [
        { title: "Ingreso Mensual", value: `${totalIngresoMensual} UF` },
        { title: "Meta Trimestral", value: `${totalMetaTrimestral} UF` },
        { title: "Ingresos Acumulados", value: `${totalIngresos} UF` },
        { title: "Meta Anual", value: `${totalMetaAnual} UF` },
        { title: "Avance Meta Anual", value: `${avgAvance}%` },
        { title: "Cierres Anuales", value: `${totalCierres}` },
    ];

    useEffect(() => {
        if (!isMobile) return;
        const timer = setTimeout(() => {
            setCurrentIndex((prev) => (prev + 1) % cardsData.length);
        }, 5000);
        return () => clearTimeout(timer);
    }, [currentIndex, isMobile, cardsData.length]);

    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    const minSwipeDistance = 50;

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;

        if (isLeftSwipe) {
            setCurrentIndex((prev) => (prev + 1) % cardsData.length);
        } else if (isRightSwipe) {
            setCurrentIndex((prev) => (prev === 0 ? cardsData.length - 1 : prev - 1));
        }
    };

    return (
        <Box
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
        >
            <Grid container spacing={2} sx={{ alignContent: 'stretch', flexGrow: 1 }}>
                {cardsData.map((card, idx) => {
                    if (isMobile && idx !== currentIndex) return null;
                    return (
                        <Grid item xs={12} sm={4} md={12} lg={12} key={idx} sx={{ display: 'flex' }}>
                            <Card
                                variant="outlined"
                                sx={{
                                    borderRadius: 2,
                                    textAlign: "center",
                                    borderColor: "#00a62b",
                                    borderWidth: 3,
                                    width: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    height: '100%',
                                }}
                            >
                                <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontWeight: 900,
                                            color: '#333',
                                            letterSpacing: 0.5,
                                            textTransform: 'uppercase',
                                            display: "block",
                                            mb: 1,
                                            lineHeight: 1.2
                                        }}
                                    >
                                        {card.title}
                                    </Typography>
                                    <Typography variant="h5" sx={{ fontWeight: "900", color: "#000" }}>
                                        {card.value}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                })}
            </Grid>
            {isMobile && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, gap: 1 }}>
                    {cardsData.map((_, idx) => (
                        <Box
                            key={idx}
                            onClick={() => setCurrentIndex(idx)}
                            sx={{
                                width: idx === currentIndex ? 16 : 8,
                                height: 8,
                                borderRadius: 4,
                                bgcolor: idx === currentIndex ? '#00a62b' : '#ccc',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                        />
                    ))}
                </Box>
            )}
        </Box>
    );
};
